
type CssList = string | { [key:string] : boolean };

/**
 * 引数に渡されたクラス名を結合して返却
 * ・引数が文字列の場合、そのまま返却する
 * ・引数がオブジェクトの場合、keyがtrueのものだけを返却する
 *   例: cssList('class1', 'class2', { 'class3': true, 'class4': false }) => 'class1 class2 class3'
 * @param classes
 */
export function cssList(...classes: CssList[]) {
  return classes
    .flatMap((cls) => {
      if (cls === null || cls === undefined) {
        // nullやundefinedの場合は空文字列を返す
        return null;
      }
      if (typeof cls === 'string') {
        // 引数が文字列の場合、そのまま返す
        return cls;
      } 
      // 引数がオブジェクトの場合、keyがtrueのものだけを返す
      return Object.keys(cls).filter((key) => cls[key]);
    })
    .filter((cls) => cls !== null)
    .join(' ');
}
